import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import gsap from 'gsap'

import colors from 'styles/colors'
import text from 'styles/text'

type Props = {
  text: string
  botPerc: number
  topPerc: number
}

const HeadingAnimation: React.FC<Props> = ({ text, botPerc, topPerc }) => {

  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement | null>(null)
  const [text2Ref, setText2Ref] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (wrapperRef && text2Ref) {
      const tl = gsap.timeline({
        scrollTrigger: {
          scroller: '.smooth-scroll',
          trigger: wrapperRef,
          scrub: true,
          start: "top 65%",
          end: "top top"
        },
      })

      tl.to(text2Ref, {
        x: '-0.59vw', 
        y: '1.04vw'
      }, 0)
  
      return () => {
        tl.kill()
      }
    }
  }, [wrapperRef, text2Ref])

  return (
    <Wrapper ref={ref => setWrapperRef(ref)} botPerc={botPerc} topPerc={topPerc}>
      <Div1 >{text}</Div1>
      <Div2 ref={ref => setText2Ref(ref)}>{text}</Div2>
    </Wrapper>
  )
}

export default HeadingAnimation

const Div = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

const Div1 = styled(Div)`
  color: ${colors.pureWhite};
`

const Div2 = styled(Div)`
  position: absolute;
  transform: translate3d(0, 0, 0);
  ${text.style.outline}
`

const Wrapper = styled.div<{botPerc: number, topPerc: number}>`
  position: relative;
  width: 100%;

  ${Div1} {
    clip-path: polygon(0 0, ${props => props.topPerc}% 0, ${props => props.botPerc}% 100%, 0% 100%);
  }

  ${Div2} {
    clip-path: polygon(${props => props.topPerc}% 0, 100% 0, 100% 100%, ${props => props.botPerc}% 100%);
  }
`


